/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.7",
    versionName: "0.2.0-nightly.2025.8.7",
    versionChannel: "nightly",
    buildDate: "2025-08-07T00:08:15.112Z",
    commitHash: "8920a9d67f40cc5cf6251867056ec0be249af99a",
};
